import React, { useRef } from 'react';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';
import _s from './index.less';

const siteKey = '6Lf6ULMmAAAAAIyMBeFPXiR0QyN2Uue2AzpWEIiW';

const ReCaptcha = ({ onVerify }) => {
  const captchaRef = useRef(null);
  const onChange = async token => {
    verifyToken(token)
      .then(response => {
        if (!response.success && onVerify) onVerify(false);
        if (response.success && onVerify) onVerify(true);
      })
      .catch(() => {
        if (onVerify) onVerify(false);
      });
  };
  return (
    <ReCAPTCHA className={_s.recaptcha} sitekey={siteKey} onChange={onChange} ref={captchaRef} />
  );
};

export const verifyToken = async token => {
  try {
    const response = await axios.post(`/api/recaptcha-verify`, {
      token
    });

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export default ReCaptcha;
